import {
  ListAttendeesCommand,
  ListAttendeesCommandOutput,
  ListAttendeesCommandInput,
  Attendee,
} from "@aws-sdk/client-chime-sdk-meetings";
import { getChimeClient } from "./get-chime-client";
import ToasterWithMessage from "../../components/toaster";
import { deleteChimeMeeting } from "./delete-meeting";

const { error: errorToast } = ToasterWithMessage();

export const getChimeParticipants = async (
  MeetingId: string
): Promise<ListAttendeesCommandOutput | undefined> => {
  try {
    const chimeClient = await getChimeClient();
    const allAttendees: Attendee[] = [];
    let nextToken: string | undefined = undefined;

    do {
      const input: ListAttendeesCommandInput = {
        MeetingId,
        NextToken: nextToken,
      };

      const command = new ListAttendeesCommand(input);
      const response = await chimeClient.send(command);

      if (response.Attendees) {
        allAttendees.push(...response.Attendees);
      }
      nextToken = response.NextToken;
    } while (nextToken);

    console.log("[Log] Attendees list response:", allAttendees);

    return {
      $metadata: {},
      Attendees: allAttendees,
    };
  } catch (error: any) {
    if (/Meeting .* not found/i.test(error.message)) {
      // Return an empty list if the meeting no longer exists (likely due to no participants).
      return { $metadata: {}, Attendees: [] };
    } else {
      // errorToast(error.message);
    }
    console.error("[Log] Failed to fetch attendees for the meeting:", error.message || error);
  }
};
